import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Craft from "@/pages/Craft";
import About from "@/pages/About";
import OurStory from "@/pages/OurStory";
import Partners from "@/pages/Partners";
import Cart from "@/pages/Cart";
import Success from "@/pages/Success";
import InsidersUnsubscribe from "@/pages/InsidersUnsubscribe";
import Admin from "@/pages/Admin";
import Privateer from "@/pages/Privateer";
import Inventory from "@/pages/Inventory";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import SurvivalBrief from "@/pages/SurvivalBrief";
import ComingSoon from "@/pages/ComingSoon";
import Mission from "@/pages/Mission";
import StarMap from "@/pages/StarMap";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import PartnerAuth from "@/pages/PartnerAuth";
import PartnerAgreement from "@/pages/PartnerAgreement";
import PartnerDashboard from "@/pages/PartnerDashboard";
import PartnerOwnerAdmin from "@/pages/PartnerOwnerAdmin";
import AffiliateGo from "@/pages/AffiliateGo";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import TenantBanner from "@/components/TenantBanner";
import CreatorHubBar from "@/components/CreatorHubBar";
import CommandVacancyBanner from "@/components/CommandVacancyBanner";
import CookieShield from "@/components/CookieShield";
import Seo from "@/components/Seo";
import ConciergeWidget from "@/components/ConciergeWidget";
import { CartProvider } from "@/context/CartContext";
import { TenantProvider } from "@/context/TenantContext";
import { PartnerAuthProvider } from "@/context/PartnerAuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { useLocation } from "react-router-dom";

function Layout({ children }) {
    const { pathname } = useLocation();
    const hideConcierge = pathname.startsWith("/admin") || pathname.startsWith("/partner") || pathname.startsWith("/privateer");
    const hideCreatorHub = pathname.startsWith("/admin") || pathname.startsWith("/partner") || pathname.startsWith("/privateer");
    return (
        <div className="App flex flex-col min-h-screen">
            <Seo />
            {!hideCreatorHub && <CreatorHubBar />}
            <TenantBanner />
            <Nav />
            <main className="flex-1">{children}</main>
            <Footer />
            <CookieShield />
            {!hideConcierge && <ConciergeWidget />}
        </div>
    );
}

function App() {
    return (
        <TenantProvider>
            <CartProvider>
                <PartnerAuthProvider>
                    <LanguageProvider>
                    <BrowserRouter>
                    <Toaster
                        position="top-center"
                        toastOptions={{
                            style: {
                                background: "var(--ig-forest)",
                                color: "var(--ig-cream)",
                                border: "1px solid var(--ig-gold)",
                                fontFamily: "Montserrat, sans-serif",
                                letterSpacing: "0.05em",
                            },
                        }}
                    />
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/shop" element={<Navigate to="/inventory" replace />} />
                            <Route
                                path="/shop/:slug"
                                element={<ProductDetail />}
                            />
                            <Route path="/coming-soon" element={<ComingSoon />} />
                            <Route path="/craft" element={<Navigate to="/shop" replace />} />
                            <Route path="/craft" element={<Craft />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/story" element={<OurStory />} />
                            <Route path="/our-story" element={<Navigate to="/story" replace />} />
                            <Route path="/mission" element={<Mission />} />
                            <Route path="/partners" element={<Partners />} />
                            <Route path="/star-map" element={<StarMap />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/success" element={<Success />} />
                            <Route path="/insiders/unsubscribe" element={<InsidersUnsubscribe />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/privateer" element={<Privateer />} />
                            <Route path="/inventory" element={<Inventory />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="/survival-brief" element={<Navigate to="/about" replace />} />
                            <Route path="/checkout/success" element={<CheckoutSuccess />} />
                            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                            <Route path="/partner/auth" element={<PartnerAuth />} />
                            <Route path="/partner/agreement" element={<PartnerAgreement />} />
                            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
                            <Route path="/partner/owner" element={<PartnerOwnerAdmin />} />
                            <Route path="/go/:slug" element={<AffiliateGo />} />
                        </Routes>
                    </Layout>
                </BrowserRouter>
                    </LanguageProvider>
                </PartnerAuthProvider>
            </CartProvider>
        </TenantProvider>
    );
}

export default App;
